module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('a', {
    attrs: {
      "id": "sec9"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("FROM")]), _vm._v(" "), _c('em', [_vm._v("The Bride of E")])]), _vm._v(" "), _c('h4', {
    staticClass: "h4"
  }, [_c('a', {
    attrs: {
      "id": "sec10"
    }
  }), _vm._v("And as in Alice")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Alice cannot be in the poem, she says, because"), _c('br'), _vm._v("She’s only a metaphor for childhood"), _c('br'), _vm._v("And a poem is a metaphor already"), _c('br'), _vm._v("So we’d only have a metaphor")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Inside a metaphor. Do you see?"), _c('br'), _vm._v("They all nod. They see. Except for the girl"), _c('br'), _vm._v("With her head in the rabbit hole. From this vantage,"), _c('br'), _vm._v("Her bum looks like the flattened backside")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Of a black-and-white panda. She actually has one"), _c('br'), _vm._v("In the crook of her arm."), _c('br'), _vm._v("Of course it’s stuffed and not living."), _c('br'), _vm._v("Who would dare hold a real bear so near the outer ear?")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("She’s wondering what possible harm might come to her"), _c('br'), _vm._v("If she fell all the way down the dark she’s looking through."), _c('br'), _vm._v("Would strange creatures sing songs"), _c('br'), _vm._v("Where odd syllables came to a sibilant end at the end.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Perhaps the sounds would be a form of light hissing."), _c('br'), _vm._v("Like when a walrus blows air"), _c('br'), _vm._v("Through two fractured front teeth. Perhaps it would"), _c('br'), _vm._v("Take the form of a snake. But if a snake, it would need a tree.")]), _vm._v(" "), _c('p', {
    staticClass: "poem"
  }, [_vm._v("Could she grow one from seed? Could one make a cat?"), _c('br'), _vm._v("Make it sit on a branch and fade away again"), _c('br'), _vm._v("The moment you told it that the rude noise it was hearing was"), _c('br'), _vm._v("    rational thought"), _c('br'), _vm._v("With an axe beating on the forest door.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7afb2c70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter1_e.vue
// module id = 99
// module chunks = 0